import { Card, CardContent } from "@repo/ui";
import { Info } from "lucide-react";

type Props = {
  cible: "pc-fit" | "pami";
  campagneNom: string;
};

/**
 * Consigne commune aux deux échelles, paramétrée par la cible (plan §7.3).
 *
 * Le référent décrit LE POSTE et L'ORGANISATION, jamais lui-même ni un candidat :
 * c'est la seule chose qui distingue son questionnaire de celui du candidat, et
 * elle doit donc être dite explicitement.
 */
export function ReferentielConsigne({ cible, campagneNom }: Props) {
  return (
    <Card className="border-blue-200 bg-blue-50/60">
      <CardContent className="flex gap-3 pt-6">
        <Info className="h-5 w-5 shrink-0 text-blue-600" />
        <div className="space-y-2 text-sm text-blue-900">
          <p className="font-medium">
            Référentiel de la campagne « {campagneNom} »
          </p>
          {cible === "pami" ? (
            <>
              <p>
                Vous êtes le <strong>seul référent</strong> de cette campagne :
                ce que vous décrivez ici EST le référentiel du poste.
              </p>
              <p>
                Pour chaque dimension, indiquez le{" "}
                <strong>score attendu</strong> chez le candidat, sur une
                échelle de 0 à 10 : score bas (0 à 3), score moyen (4 à 6) ou
                score élevé (7 à 10).
              </p>
              <p>
                Les 20 dimensions sont à renseigner. Une dimension sur laquelle
                le poste n'appelle aucun profil se marque{" "}
                <strong>pas d'attente particulière</strong> : elle sort du
                calcul. Toutes les autres comptent autant dans le score.
              </p>
            </>
          ) : (
            <p>
              Classez ces éléments selon ce qui compte le plus{" "}
              <strong>
                pour réussir dans ce poste et dans votre organisation
              </strong>{" "}
              — pas selon ce qui compte pour vous personnellement.
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
